<template>
  <div class="tableContainer">
    <div class="summary-header">
      <div class="summary-title">
        <div class="summary-icon"></div>
        <div class="summary-text">
          {{ $t('ServiceCatalog.service_catalog') }}
        </div>
      </div>
    </div>
    <DxDataGrid
      :data-source="dataSourceWithPrecioDivisa"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :word-wrap-enabled="true"
      :no-data-text="$t('noDataTextSummary')"
      class="custom-grid custom-service-catalog"
      @cell-prepared="onCellPrepared"
      @toolbar-preparing="onToolbarPreparing($event)"
      @contentReady="onInit"
    >
      <DxScrolling mode="standard" />
      <DxColumn
        :caption="$t('code')"
        alignment="left"
        data-field="AnalisisTipo"
        :min-width="200"
      />
      <DxColumn
        :caption="$t('description')"
        alignment="left"
        data-field="DescripcionAT"
        :min-width="300"
      />
      <DxColumn
        :caption="$t('netAmount')"
        alignment="center"
        data-field="precioConDivisa"
        :min-width="100"
      />
      <DxColumn
        :buttons="updatedEditButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        width="80"
      />
      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[10, 20, 30]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />
      <DxPaging :page-size="10" />
    </DxDataGrid>

    <!-- <CatalogDetailsPopup
      v-if="showCatalogDetailsPopup"
      :store="servicesAnalyticsDetails"
    /> -->
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';
import { mapState, mapActions } from 'vuex';
import EventBus from '@/services/event-bus';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import iconVisibility from '@/static/icons/ic_visibility.svg';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxPager,
    DxPaging,
    DxScrolling,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
    tabKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editButtons: [
        {
          icon: iconVisibility,
          onClick: this.viewAtc,
          cssClass: 'grid-button-icon',
        },
      ],
      Empresa: '',
      idSubFamilia: '',
      idAnalisisTipo: '',
      divisa: '',
      sampleTypeTagBox: null,
      minSearchLength: 2,
    };
  },
  computed: {
    dataSourceWithPrecioDivisa() {
      return this.store.map((item) => ({
        ...item,
        precioConDivisa: `${item.precioAT} ${item.divisaAT}`,
      }));
    },
    ...mapState('serviceCatalog', [
      'showCatalogDetailsPopup',
      'servicesAnalyticsDetails',
      'servicesFamilies',
      'idFamilySelected',
      'idTipoMuestra',
      'sampleTypes',
    ]),
    updatedEditButtons() {
      return [
        {
          icon: iconVisibility,
          onClick: this.viewAtc,
          cssClass: 'grid-button-icon',
        },
      ];
    },
  },
  watch: {
    sampleTypes(newVal) {
      if (this.sampleTypeTagBox) {
        this.sampleTypeTagBox.option('items', newVal);
      }
    },
    idTipoMuestra() {
      if (this.sampleTypeTagBox) {
        this.sampleTypeTagBox.option('value', this.idTipoMuestra);
      }
    },
  },
  mounted() {
    EventBus.$on(
      'tipoMuestra-seleccionada',
      this.onTipoMuestraSeleccionada
    );
  },
  beforeDestroy() {
    EventBus.$off(
      'tipoMuestra-seleccionada',
      this.onTipoMuestraSeleccionada
    );
  },
  methods: {
    onInit(e) {
      this.grid = e;
      Array.from(
        document.getElementsByClassName('dx-group-cell')
      ).forEach((el) => {
        el.innerHTML = el.innerHTML.split(':')[1].trim();
      });
    },
    onCellPrepared(e) {
      if (e.rowType === 'data') {
        if (!e.data.seen) {
          e.cellElement.classList.add('hasntBeenSeen');
        }
      }
    },
    async viewAtc(e) {
      try {
        this.$f7.preloader.show();
        this.Empresa = e.row.data.SociedadX3v12;
        this.idAnalisisTipo = e.row.data.idAnalisisTipo;
        this.divisa = e.row.data.divisaAT;
        await this.fetchDetails(
          this.Empresa,
          this.idTipoMuestra,
          this.idAnalisisTipo,
          this.divisa
        );
        this.setPopupTitle(e.row.data.AnalisisTipo);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
        this.$f7router.navigate(
          {
            name: 'serviceCatalogDetails',
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      }
    },
    async fetchDetails(Empresa, TipoMuestra, idAnalisisTipo, divisa) {
      try {
        await this.fetchServicesAnalyticsDetails({
          Empresa,
          TipoMuestra,
          idAnalisisTipo,
          Divisa: divisa,
        });
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              'samplesRegister.pleaseSelectSampleType'
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    async sampleFinder(value) {
      // Si ha escrito al menos 2 caracteres, se filtran los tipos de muestras en base a eso
      if (!value || value.length < this.minSearchLength) return;
      try {
        this.$f7.preloader.show();
        await this.fetchSampleTypes(value);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-simple-toolbar',
      };

      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') item.location = 'before';
      });

      toolbarItems.push({
        name: 'familySelector',
        location: 'before',
        widget: 'dxSelectBox',
        locateInMenu: 'never',
        options: {
          width: 200,
          items: this.servicesFamilies,
          displayExpr: 'descripcion',
          valueExpr: 'idFamiliaTM',
          value: this.idFamilySelected,
          placeholder: 'Filtrar por familia',
          onInitialized: (ev) => {
            this.$emit(
              'selector-initialized',
              'familySelector',
              this.tabKey,
              ev.component
            );
          },
          onValueChanged: (event) => {
            // Ignorar cambios programáticos (restore/sync)
            if (!event.event) return;

            // Ignorar si no hay cambio real
            if (event.value === this.idFamilySelected) return;

            this.setIdFamilySelected(event.value);
            this.setIdTipoMuestra(null);

            if (this.sampleTypeTagBox) {
              this.sampleTypeTagBox.option('value', null);
              this.setSampleTypes([]);
            }
          },
        },
      });

      toolbarItems.push({
        name: 'sampleTypeSelector',
        location: 'before',
        widget: 'dxSelectBox',
        locateInMenu: 'never',
        options: {
          width: 230,
          items: this.sampleTypes,
          displayExpr: 'descripcion',
          valueExpr: 'idTipoMuestra',
          value: this.idTipoMuestra,
          placeholder: this.$t('samplesRegister.SearchSampleType'),
          searchEnabled: true,
          maxDisplayedTags: 15,
          minSearchLength: 2,
          showDropDownButton: true,
          multiline: false,
          pageLoadMode: 'scrollBottom',
          onInitialized: (eventObj) => {
            this.sampleTypeTagBox = eventObj.component;

            // ✅ FIX: emitir la instancia correcta del select
            this.$emit(
              'selector-initialized',
              'sampleTypeSelector',
              this.tabKey,
              eventObj.component
            );
          },
          onInput: (eventObj) => {
            this.searchText = eventObj.event?.target?.value;
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
              this.sampleFinder(this.searchText);
            }, 1500);
          },
          onValueChanged: (eventObj) => {
            if (!eventObj.event) return;

            const value = Array.isArray(eventObj.value)
              ? eventObj.value[0]
              : eventObj.value;

            if (value == null) return;

            this.setIdTipoMuestra(value);
          },
        },
      });
    },
    ...mapActions('serviceCatalog', [
      'setShowCatalogDetailsPopup',
      'setPopupTitle',
      'fetchServicesAnalyticsDetails',
      'setIdFamilySelected',
      'setIdTipoMuestra',
      'fetchSampleTypes',
      'setSampleTypes',
    ]),
  },
};
</script>
<style lang="scss">
@import './packsAnalytics.styles.scss';
</style>
